import { UIText2 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IRowProps {
  columnsWidths: number[] | null;
  onClick?(): void;
}

export const HeaderRow: React.VFC<IRowProps> = ({ onClick, columnsWidths }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (columnsWidths && ref.current) {
      const headerColumns = ref.current.children;

      columnsWidths.forEach((width, i) => {
        if (headerColumns[i]) {
          (headerColumns[i] as HTMLDivElement).style.width = `${width}px`;
        }
      });
    }
  }, [columnsWidths]);

  return (
    <div ref={ref} className={styles['header']} onClick={onClick}>
      <div className={styles['cell']} />
      <div className={styles['cell']}>
        <UIText2 color="current_color">Цена</UIText2>
      </div>
      <div className={cn(styles['cell'], styles['l'])}>
        <UIText2 color="current_color">На Циан</UIText2>
      </div>
      <div className={styles['cell']}>
        <UIText2 color="current_color">Опубликовано</UIText2>
      </div>
      <div className={styles['cell']}>
        <UIText2 color="current_color">Снято</UIText2>
      </div>
    </div>
  );
};
